import React from 'react';
import { WidgetDateTime, WidgetStatus } from '../../../../components';
import statuses from '../../../../constants/emails/statuses';
import { useTranslation } from 'react-i18next';
import { headerSortingClasses, sortCaret } from '../../../../helpers';

export default function EmailColumns () {
    const { t } = useTranslation();
    return [{
        dataField: 'id',
        text: t('email.table.columns.id'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'description',
        text: t('email.table.columns.email'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    },
    {
        dataField: 'created_at',
        text: t('email.table.columns.created_at'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => {
            return (
                <WidgetDateTime date={new Date(cellContent)} />
            );
        }
    }, {
        dataField: 'updated_at',
        text: t('email.table.columns.updated_at'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => {
            return (
                cellContent && <WidgetDateTime date={new Date(cellContent)} />
            );
        }
    }, {
        dataField: 'active',
        text: t('email.table.status.title'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetStatus type={statuses[cellContent]?.type} text={`email.table.status.${statuses[cellContent]?.id}`} />)
    }];
}
